module.exports = __webpack_public_path__ + "img/adf-army.eb60e1d.webp";